import {save} from "../operations/save";

export function saveCell(row, column, page){
	const cell = (page ? this._mData.getPage(page) : this._mPage).getCell(row-1, column-1);

	save(this, "data", {
		row,
		column,
		value: this.getCellValue(row, column, null, page),
		page: page || this.getActiveSheet(),
		style: (cell ? cell.style : "") || ""
	});
}